import PageHeader from "@/components/PageHeader";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

/**
 * ReportPageShell — shared layout for the 5 Phase 8 reports.
 * Props:
 *   title, subtitle, headerActions, chartTitle, chart (ReactNode), table (ReactNode)
 */
export default function ReportPageShell({
  title, subtitle, headerActions, filters, chartTitle, chart, table, testId,
}) {
  return (
    <div className="p-6 space-y-6" data-testid={testId}>
      <PageHeader testId={`${testId}-header`} title={title} subtitle={subtitle} actions={headerActions} />
      {filters && (
        <Card className="rounded-md">
          <CardContent className="p-4 flex flex-wrap items-center gap-3">
            {filters}
          </CardContent>
        </Card>
      )}
      {chart && (
        <Card className="rounded-md">
          {chartTitle && (
            <CardHeader className="pb-2">
              <CardTitle className="text-sm font-medium">{chartTitle}</CardTitle>
            </CardHeader>
          )}
          <CardContent className="pt-2">{chart}</CardContent>
        </Card>
      )}
      <Card className="rounded-md overflow-hidden">
        <CardContent className="p-0">{table}</CardContent>
      </Card>
    </div>
  );
}
